import { useMutation, useQueryClient } from '@tanstack/react-query';
import { BaseResponseEntity, UserWalletAuthService } from 'services/openapi';
import { UserServiceQueryKeys } from 'services/user/constants';

export const useAdminResetTwoFaMutation = () => {
  const queryClient = useQueryClient();
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<BaseResponseEntity, Error, string>({
      mutationFn: (userId: string) =>
        UserWalletAuthService.authControllerAdminResetTwoFa(userId),
      onSuccess: (_data, userId) =>
        Promise.all([
          queryClient.invalidateQueries([
            UserServiceQueryKeys.GET_USER_INFO,
            { userId },
          ]),
          queryClient.invalidateQueries([UserServiceQueryKeys.GET_USERS_LIST]),
        ]),
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
